// extracted by mini-css-extract-plugin
export default {"blankSpace":"Footer_blankSpace__xzUTk"};